import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { INomenclatureState } from "@/store/modules/nomenclature/state";
import { NomenclatureMutations } from "@/store/modules/nomenclature/mutations";
import { CompanyMutations } from "@/store/modules/company/mutations";

export enum NomenclatureActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_NOMENCLATURE",
  FETCH_ONE = "FETCH_ONE_NOMENCLATURE",
  FETCH_ALL = "FETCH_ALL_NOMENCLATURE",
  CREATE = "CREATE_NOMENCLATURE",
  UPDATE = "UPDATE_NOMENCLATURE",
  DELETE = "DELETE_NOMENCLATURE",
  DELETE_ALL = "SET_ALL_NOMENCLATURE",
}

export const actions: ActionTree<INomenclatureState, IRootState> = {
  async [NomenclatureActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/documents/nomenclature/list", {
        params: params,
      });
      commit(NomenclatureMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("get job data provider error: ", error);
    }
  },
  async [NomenclatureActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/documents/nomenclature/view/${id}`);
      commit(NomenclatureMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch nomenclature one error: ", error);
    }
  },
  async [NomenclatureActions.FETCH_ALL]({ commit }) {
    try {
      const result = await baseApi.get(
        "/documents/document/sub-data/nomenclatures"
      );
      commit(NomenclatureMutations.SET_ALL, result.data.data.items);
    } catch (error) {
      console.log("fetch job all error: ", error);
    }
  },
  async [NomenclatureActions.CREATE]({ commit }, data: Document) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/documents/nomenclature/create", data)
        .then((data) => {
          commit(CompanyMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("job create error: ", error);
          reject(error.response);
        });
    });
  },
  async [NomenclatureActions.UPDATE]({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(`/documents/nomenclature/update/${id}`, data)
        .then((data) => {
          commit(CompanyMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("job update error: ", error);
          reject(error.response);
        });
    });
  },
  async [NomenclatureActions.DELETE]({ commit }, id: string) {
    try {
      await baseApi.delete(`/documents/nomenclature/delete/${id}`);
    } catch (error) {
      console.log("job delete error:", error);
    }
  },
  async [NomenclatureActions.DELETE_ALL]({ commit }) {
    try {
      await baseApi.delete(`/documents/nomenclature`);
      commit(NomenclatureMutations.SET_ALL, []);
    } catch (error) {
      console.log("company delete all", error);
    }
  },
};
